// FAR-83 #13: the Capacity and SKU Plan cards scroll sideways together, so
// their months stay lined up. These are the rules; useSyncedScrollX.js wires
// them to the DOM. Pure, so they are tested without a browser.

// Positions closer than this are the same (browsers report fractions).
const SAME = 1

const same = (a, b) => Math.abs(a - b) < SAME

// A box fired `scroll`. `left` is its scrollLeft now, `lastWritten` what we
// last wrote to it (null if nothing pending), `otherLeft` the other box's
// scrollLeft (null if it isn't mounted).
// - echo: this is the event from our own write; do nothing.
// - write: the value to copy to the other box, or null.
// Either way the caller clears this box's record: an echo is used up, and a
// real scroll means any echo still pending is stale. (During a trackpad or
// momentum scroll the echo can arrive after the user moved on; treating it as
// a user scroll would write the old position back and stall the scroll.)
export function onScroll(left, lastWritten, otherLeft) {
  if (lastWritten != null && same(left, lastWritten)) return { echo: true, write: null }
  return { echo: false, write: copyTo(left, otherLeft) }
}

// The value to write so a box at `toLeft` follows one at `fromLeft`, or null
// when they already match (or the box isn't there). A vertical scroll of the
// SKU grid fires `scroll` with no sideways change, so this returns null and
// nothing is written or recorded.
export function copyTo(fromLeft, toLeft) {
  if (toLeft == null || fromLeft == null) return null
  return same(fromLeft, toLeft) ? null : fromLeft
}

// After writing scrollLeft, what to record as the pending echo. A write that
// didn't move the box (already at its end, so the browser clamped it) fires
// no event, so nothing is recorded; otherwise the read-back value is, since
// the browser may round or clamp what was written.
export function recordAfterWrite(before, after) {
  return same(before, after) ? null : after
}
